// Must run before any @api-client/auth/auth import (e.g. via DeviceView → MyStoresStore)
import "./nwAuthStorage";
import "@/index.css";
import { initSentry } from '@autoprint-spa/instrument';
import { createApp } from 'vue'
import DeviceView from './DeviceView.vue'
import { focusGlobalWindow } from "./focusGlobalWindow";
import { openAlwaysTopOnWindow } from "./openAlwaysTopOnWindow";
import { restartApp } from "./restartApp";
import { syncAutoStartOnBoot } from "./autoStart";
import { connectionWatchdogTick, startConnectionWatchdog } from "./connectionWatchdog";
import { keepaliveTickMaybeRecover, recoverAfterSleep } from "./resumeAfterSleep";
import { startKeepAwake } from "./keepAwake";
import { startProcessWatchdog, writeHeartbeat } from "./processWatchdog";

const startedAt = Date.now();
const checkRestartDue = () => {
    if (Date.now() - startedAt >= 12 * 60 * 60 * 1000) {
        restartApp();
    }
};

const autoprintKeepAliveTick = () => {
    writeHeartbeat();
    keepaliveTickMaybeRecover();
    connectionWatchdogTick();
    checkRestartDue();
};

const focusAndRecover = () => {
    recoverAfterSleep();
    focusGlobalWindow();
};

if (typeof global !== "undefined") {
    global.mainWindow = nw.Window.get();
    setTimeout(() => {
        global.mainWindow?.hide();
    });
    global.mainWindow.on('closed', function () {
        global.mainWindow?.hide();
    });
    global.mainWindow.on('close', function () {
        global.mainWindow?.hide();
    });
    if (import.meta.env.DEV) {
        global.mainWindow.showDevTools();
    }
    focusGlobalWindow();
    // Tray calls this — recover dead pusher after sleep before showing UI
    global.focusGlobalWindow = focusAndRecover;
    global.restartApp = restartApp;
    global.autoprintKeepAliveTick = autoprintKeepAliveTick;
    syncAutoStartOnBoot();
    startKeepAwake();
    startProcessWatchdog();
} else {
    // Browser Vite: tray is an iframe; also expose on window for parent calls + local fallback
    (window as any).autoprintKeepAliveTick = autoprintKeepAliveTick;
}
window.addEventListener('online', recoverAfterSleep);
// NW: hidden main window can be throttled; also tick here (tray ticks too — harmless)
setInterval(autoprintKeepAliveTick, 60_000);
openAlwaysTopOnWindow();
startConnectionWatchdog();

setTimeout(() => {
    const app = createApp(DeviceView);
    initSentry(app);
    app.mount('#app');
});
